<template>
<div>
    <div class="container">
        <logo/>
        <login-form redirect="Dashboard"/>
    </div>
</div>
</template>

<script>

    import LoginForm from './LoginForm.vue';
    import Logo from '../layout/CenterLogo.vue';

    export default {
        name: 'LoginPage',
        metaInfo: {
        title: 'Login',
            meta: [
              {vmid:'description', name: 'description', content: 'Login into your Pimblr Account'},
              {vmid:'title', name: 'title', content: 'Login'}
            ]
        },
        data(){
            return {

            }
        },
        created() {
            if(this.$store.getters['user/isLoggedIn']) this.$router.push({name:'Dashboard'});
        },
        methods: {},
        components:{
            'login-form': LoginForm,
            Logo
        }

    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/user/LoginPage.vue